import { fetcher } from '@commenda/utils';

export type TAssignPendingServiceRequestAssignmentParams = {
  pendingAssignmentId: string;
  /** Omit when the user has no companies — the backend creates one. */
  companyId?: number;
  /** Display name for the company created when companyId is omitted. */
  companyName?: string;
};

export type TAssignPendingServiceRequestAssignmentResponse = {
  serviceRequestId: string;
  companyId: number;
};

/** Attach a paid self-serve purchase to a company, creating its service request. */
export const assignPendingServiceRequestAssignment = async (
  params: TAssignPendingServiceRequestAssignmentParams
): Promise<Response> => {
  const { pendingAssignmentId, companyId, companyName } = params;

  return fetcher(
    `self-serve-incorporation/pending-assignments/${pendingAssignmentId}/assign`,
    {
      method: 'POST',
      body: { companyId, companyName },
    },
    undefined
  );
};
